import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const ROAST_MESSAGES = [
  "Scanning for overused buzzwords...",
  "Judging your font choices...",
  "Laughing at 'detail-oriented'...",
  "Finding all the typos...",
  "Preparing maximum emotional damage..."
];

const SERIOUS_MESSAGES = [
  "Processing secure payment...",
  "Engaging Professional AI Agent...",
  "Rewriting bullet points...",
  "Calculating ATS optimization score...",
  "Finalizing actionable feedback..."
];

export default function LoadingView({ type = 'roast', onComplete }) {
  const [messageIndex, setMessageIndex] = useState(0);
  const messages = type === 'roast' ? ROAST_MESSAGES : SERIOUS_MESSAGES;
  const colorClass = type === 'roast' ? 'text-rose-500' : 'text-emerald-500';

  useEffect(() => {
    let currentIndex = 0;
    const interval = setInterval(() => {
      currentIndex++;
      if (currentIndex < messages.length) {
        setMessageIndex(currentIndex);
      }
    }, 1200);

    const timeout = setTimeout(() => {
      clearInterval(interval);
      onComplete();
    }, messages.length * 1200);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [messages.length, onComplete]);

  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 1.1 }}
      className="flex flex-col items-center justify-center py-20"
    >
      <div className="relative w-32 h-32 mb-8">
        <motion.div 
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          className={`absolute inset-0 rounded-full border-4 border-t-transparent border-r-transparent ${type === 'roast' ? 'border-rose-500' : 'border-emerald-500'} opacity-20`}
        />
        <motion.div 
          animate={{ rotate: -360 }}
          transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
          className={`absolute inset-4 rounded-full border-4 border-b-transparent border-l-transparent ${type === 'roast' ? 'border-orange-500' : 'border-cyan-500'} opacity-40`}
        />
        <div className="absolute inset-0 flex items-center justify-center text-4xl">
          {type === 'roast' ? '🔥' : '⚙️'}
        </div>
      </div>
      
      <motion.p
        key={messageIndex}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        className={`text-xl font-medium text-center h-8 ${colorClass}`}
      >
        {messages[messageIndex]}
      </motion.p>
    </motion.div>
  );
}